const DEFAULT_DATE_OPTIONS = {
  month: "long",
  day: "numeric",
  year: "numeric",
};

export function parseDateOnly(value) {
  if (!value) return null;

  const datePart = String(value).split("T")[0];
  const [year, month, day] = datePart.split("-").map(Number);

  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
}

export function formatDateOnly(value, options = DEFAULT_DATE_OPTIONS) {
  const date = parseDateOnly(value);
  return date ? date.toLocaleDateString(undefined, options) : "";
}

export function compareDateOnlyDesc(a, b) {
  const left = parseDateOnly(a)?.getTime() || 0;
  const right = parseDateOnly(b)?.getTime() || 0;
  return right - left;
}

export function isDateOnlyValue(value) {
  return /^\d{4}-\d{2}-\d{2}$/.test(String(value || "").trim());
}

export function parseCalendarDate(value) {
  if (!value) return null;

  const raw = String(value).trim();
  if (isDateOnlyValue(raw)) {
    return parseDateOnly(raw);
  }

  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatCalendarDate(value, options) {
  const date = parseCalendarDate(value);
  return date ? date.toLocaleDateString(undefined, options) : String(value || "");
}

export function formatCalendarDateTime(value, { dateOptions, timeOptions } = {}) {
  if (!value) return "-";

  const date = parseCalendarDate(value);
  if (!date) return String(value);

  if (isDateOnlyValue(value)) {
    return date.toLocaleDateString(undefined, dateOptions);
  }

  const dateText = date.toLocaleDateString(undefined, dateOptions);
  const timeText = date.toLocaleTimeString(undefined, timeOptions);
  return timeText ? `${dateText}, ${timeText}` : dateText;
}
